module.exports = {"420322100":"城关镇","420322101":"土门镇","420322102":"上津镇","420322103":"店子镇","420322104":"夹河镇","420322105":"羊尾镇","420322106":"观音镇","420322107":"马鞍镇","420322108":"河夹镇","420322200":"香口乡","420322201":"关防乡","420322202":"湖北口回族乡","420322203":"景阳乡","420322204":"六郎乡","420322205":"涧池乡","420322206":"安家乡","420322400":"槐树林特场管委会","420322401":"三官洞林区","420322402":"工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420322.json
// module id = 1571
// module chunks = 0